import { render, staticRenderFns } from "./marketing-wrapper.vue?vue&type=template&id=2cc0d8a6"
import script from "./marketing-wrapper.vue?vue&type=script&lang=js"
export * from "./marketing-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports